import { createAsyncThunk } from '@reduxjs/toolkit';

import { MEDIA_CONTENT_PLACEMENT, MEDIA_TYPES } from '../../constants';
import sendRequest from '../../service/sendRequest';
import callApi from '../../service/callApi';
import buildQuery from '../../utils/buildQuery';

const GET_PLATFORM_INFO = 'platforms/GET_PLATFORM_INFO';

export const getPlatformInfo = createAsyncThunk(
  GET_PLATFORM_INFO,
  async ({ type = MEDIA_TYPES.IMAGE, placement = MEDIA_CONTENT_PLACEMENT.SINGLE }, { rejectWithValue }) => {
    const query = buildQuery({ type, placement });
    const response = await sendRequest(() => callApi.get(`/api/media/platforms?${query}`), {
      onError: (e) => {
        return rejectWithValue(e);
      },
    });

    return response.data;
  },
);
